import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackTechDocsPageView } from '../telemetry';

/**
 * Invisible component that fires a `TechDocsPageView` Application Insights
 * event every time the TechDocs route changes.
 *
 * Mount inside `<TechDocsReaderPage>` children so it only activates
 * when the user is actually viewing a doc.
 */
export function TechDocsViewTracker(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    trackTechDocsPageView(pathname);
  }, [pathname]);

  return null;
}
